'use client';

import React from 'react';
import Link from 'next/link';

export default function AIFinalCTA() {
  return (
    <section className="py-24 px-6 relative overflow-hidden">
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            'radial-gradient(ellipse 60% 80% at 50% 50%, rgba(124,58,237,0.14) 0%, transparent 70%)',
        }}
      />

      <div className="relative max-w-5xl mx-auto">
        <div className="reveal-blur bento-card card-shine finalcta-card relative p-10 md:p-16 overflow-hidden text-center">
          {/* Glow orbs */}
          <div
            className="absolute -top-20 -left-20 w-80 h-80 rounded-full pointer-events-none"
            style={{
              background: 'radial-gradient(circle, rgba(124,58,237,0.2) 0%, transparent 70%)',
              filter: 'blur(40px)',
            }}
          />
          <div
            className="absolute -bottom-20 -right-20 w-80 h-80 rounded-full pointer-events-none"
            style={{
              background: 'radial-gradient(circle, rgba(167,139,250,0.15) 0%, transparent 70%)',
              filter: 'blur(40px)',
            }}
          />
          <div
            className="absolute inset-0 pointer-events-none opacity-10"
            style={{
              backgroundImage: 'radial-gradient(rgba(167,139,250,0.5) 1px, transparent 1px)',
              backgroundSize: '32px 32px',
            }}
          />

          <div className="relative z-10">
            <div className="inline-flex items-center gap-2 w-fit px-4 py-1.5 rounded-full border border-[rgba(124,58,237,0.3)] mx-auto mb-6">
              <span className="w-1.5 h-1.5 rounded-full bg-[#A78BFA] status-pulse" />
              <span className="text-[10px] font-mono text-[#A78BFA] tracking-widest uppercase">
                Closing thought
              </span>
            </div>

            <h2
              className="font-manrope font-extrabold tracking-tighter text-[#EEEEF0] leading-tight"
              style={{ fontSize: 'clamp(1.75rem, 4vw, 3.25rem)' }}
            >
              The next decade in real estate software
              <br />
              <span
                style={{
                  background: 'linear-gradient(135deg, #7C3AED, #A78BFA)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                }}
              >
                belongs to the best autonomous workflows.
              </span>
            </h2>

            <p className="mt-6 text-base md:text-lg text-[#9999A8] max-w-2xl mx-auto leading-relaxed">
              MRI, Yardi, and AppFolio have the head start. But they have 20–40 years of legacy code never
              designed for agentic AI. Propmatic&apos;s bet is simple — build the answer from scratch.
            </p>

            <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
              <Link
                href="/landing#demo"
                className="cta-primary inline-flex items-center gap-2 px-6 py-3 rounded-xl text-sm tracking-tight shadow-violet-glow-lg"
              >
                See Your Portfolio Live
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M5 12h14M12 5l7 7-7 7" />
                </svg>
              </Link>
              <Link
                href="/landing"
                className="cta-secondary inline-flex items-center gap-2 px-6 py-3 rounded-xl text-sm"
              >
                Back to Propmatic
              </Link>
            </div>

            <div className="mt-8 text-[10px] font-mono text-[#5A5A6E]">
              Document v1.0 · Updated April 2026 · Prepared for Propmatic MVP
            </div>
          </div>

          <div className="scan-line" />
        </div>
      </div>
    </section>
  );
}
